import { isBrowser, postJson } from '@zapier/common-utils';
import { TrackingMiddleware } from '../types';
const CONTEXT_ENV = isBrowser() ? 'client' : 'server';

const sendToBackend: TrackingMiddleware = config => async event => {
  const { service } = config.get(['service']);
  await postJson('/api/v3/events', {
    message: event.name,
    data: {
      ...event.data,
      ...event._deprecatedBuildProprtiesInRoot(),
      _data: event.data,
      _context: {
        [`${service || ''}__${CONTEXT_ENV}`]: event.context,
      },
    },
  });
};

export default sendToBackend;
